export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ01.bc3e957c.mp3";